import { t } from "@/utils";
import Dialog, { DialogProps } from "@/components/Dialog";
import ErrorIcon from "assets/icons/error.svg?react";

type Props = {
  isOpen: boolean;
  onClose: Cb;
  goToHelp: Cb;
  props: DialogProps["props"];
};

export default function PairingQrCodeFailureDialog({ isOpen, onClose, goToHelp, props }: Props) {
  return (
    <Dialog
      icon={ErrorIcon}
      iconProps={{ fill: "error" }}
      props={props}
      isOpen={isOpen}
      onClose={goToHelp}
      onConfirm={onClose}
      buttons={{
        cancel: { label: t("howToGetCode") },
        confirm: { label: t("buttons.ok") }
      }}
      title={t("pairing.scanCode.errorDialog.heading")}
      body={t("pairing.scanCode.errorDialog.text")}
    />
  );
}
